// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import LocalizationSection from './LocalizationSection';
import { useDispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';

// assets
import { IconMenu2 } from '@tabler/icons-react';

import 'firebase/compat/auth';
import { useEffect } from 'react';
import SystemNotifications from './SystemNotifications';
import { getProductsToApproveCount } from 'store/slices/product';
import { getUserMulticatalog } from 'store/slices/auth';
import { openSnackbar } from 'store/slices/snackbar';
import { useIntl } from 'react-intl';
// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
    /* Token renovation */
    const { merchants, loading: authLoading, idApprovalProfile, email, vendor } = useSelector((state) => state.auth);
    const intl = useIntl();
    const dispatch = useDispatch();

    const { drawerOpen } = useSelector((state) => state.menu);

    useEffect(() => {
        if (!intl) return;
        if (drawerOpen) return;
        let errorCounter = 0;

        const getUserMenuDetails = async () => {
            if (errorCounter >= 5) {
                return dispatch(
                    openSnackbar({
                        open: true,
                        message: intl.formatMessage({
                            id: 'cannot_get_profile_menu_details'
                        }),
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: false
                    })
                );
            }

            try {
                const user = localStorage.getItem('user');
                return dispatch(getUserMulticatalog(user));
            } catch (error) {
                return setTimeout(() => {
                    errorCounter += 1;
                    getUserMenuDetails();
                }, 1000);
            }
        };
        if (drawerOpen) {
            getUserMenuDetails();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [drawerOpen]);

    const theme = useTheme();

    useEffect(() => {
        if (!idApprovalProfile || !merchants || !email) return;

        const payload: { statusId: string; email: string; providerId?: number } = {
            statusId: idApprovalProfile.toString(),
            email: email
        };

        if (vendor?.idProvider) {
            payload.providerId = Number(vendor.idProvider);
        }

        dispatch(getProductsToApproveCount(payload));
    }, [merchants, email, idApprovalProfile, vendor?.idProvider, dispatch]);

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    zIndex: 200000,
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        overflow: 'hidden',
                        transition: 'all .2s ease-in-out',
                        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
                        color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                        '&:hover': {
                            background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                            color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light
                        }
                    }}
                    onClick={() => dispatch(openDrawer(!drawerOpen))}
                    color="inherit"
                >
                    <IconMenu2 stroke={1.5} size="1.3rem" />
                </Avatar>
            </Box>

            {/* header search */}
            <SearchSection />
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* mega-menu */}
            {/* DELETED: Consult the original repository */}

            {/* live customization & localization */}
            {/* <ChatSection /> */}
            {!authLoading && <SystemNotifications />}
            <LocalizationSection />

            {/* DELETED: Consult the original repository */}

            {/* Profile */}
            <ProfileSection />

            {/* mobile header */}
            {/* DELETED: Consult the original repository */}
        </>
    );
};

export default Header;
